import React, {useContext, useEffect, useMemo} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {MaterialMovementsContext} from "../material-movements.context.jsx";
import {FaCheck} from "react-icons/fa";

const CautionsList = () => {
    const {cautions} = useContext(MaterialMovementsContext)

    const columnDefs = useMemo(() => [
        {headerName: "Entrega", field: "date", width: 140, sort: "desc"},
        {headerName: "Depósito", field: "storage_description", sortable: false, comparator: aggridUtils.lowerUpCaseComparator},
        {headerName: "Material", field: "material_description", flex: 1, sortable: false, comparator: aggridUtils.lowerUpCaseComparator},
        {
            headerName: "Permanente", field: "permanent", sortable: false, width: 100,
            cellRenderer: ({data}) => {
                if (data.permanent) {
                    return <div className={"w-full h-full flex items-center justify-center"}><FaCheck color={"green"} /></div>
                }

                return <></>
            }
        },
        {headerName: "Quantidade", field: "quantity", sortable: false, width: 100},
        {headerName: "Observação", field: "observations", flex: 1, sortable: false, width: 280},
        {
            headerName: "Avaria", field: "breakdown", sortable: false, width: 280,
            cellRenderer: ({data}) => {
                if (data.breakdown) {
                    const openBreakdownDetails = () => projectUtils.swalMessage("", "", data.breakdown, 'Ok', false, 'Não', undefined, false, "");
                    return <div className={"w-full h-full cursor-pointer hover:underline"} onClick={openBreakdownDetails}>{data.breakdown}</div>
                }

                return <></>
            },
        },
    ], []);

    const defaultColDef = useMemo(() => {
        return {
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true,
            suppressHeaderContextMenu: true,
            suppressFloatingFilterButton: true,
        };
    }, []);

    return (
        <Card className={"mt-3"}>
            <Card.Header>
                <Card.Title>Materiais em cautela</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className={"min-h-[74px]"}>
                    <AgGridReact
                        rowData={cautions || []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme({noHover: true})}
                        domLayout='autoHeight'
                        onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default CautionsList;